import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiArrowRight } from 'react-icons/fi';

const navItems = [
  { label: 'Services', path: '/services' },
  { label: 'Solutions', path: '/solutions' },
  { label: 'Work', path: '/work' },
  { label: 'About', path: '/about' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' }
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const headerClass = ['header', isScrolled && 'scrolled', isMenuOpen && 'menu-open']
    .filter(Boolean)
    .join(' ');

  return (
    <header className={headerClass}>
      <nav className="nav container" aria-label="Main">
        <Link to="/" className="logo" aria-label="Fedigma home">
          <img src="/logo-64.png" className="logo-mark" alt="" width="32" height="32" />
          Fedigma
        </Link>

        <ul id="nav-menu" className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink to={item.path} className="nav-link">
                {item.label}
              </NavLink>
            </li>
          ))}
          <li className="nav-mobile-cta">
            <Link to="/contact" className="btn btn-lg">
              Get a Quote <FiArrowRight />
            </Link>
          </li>
        </ul>

        <div className="nav-actions">
          <Link to="/contact" className="btn btn-sm">
            Get a Quote
          </Link>
          <button
            type="button"
            className="nav-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            aria-controls="nav-menu"
          >
            {isMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
